<template>
  <form id="formEncaminhar" @submit.prevent="encaminhar()" class="ajax_off">
    <div class="form-group">
      <label>Encaminhar para:</label>
      <e-select v-model="colaborador" route="colaboradores" />
    </div>
    <div class="form-group" v-if="cartao_data_entrega == null">
      <label>Data de Entrega</label>

      <input
        class="form-control"
        type="datetime-local"
        value=""
        @change.prevent="data_entrega = $event.target.value"
        required=""
      />
    </div>
    <div class="form-group" v-if="user.user_id != colaborador">
      <label>Devolver até:</label>
      <input
        class="form-control"
        name="data_devolucao"
        type="datetime-local"
        v-model="data_devolucao"
        required=""
      />
    </div>

    <div class="form-group">
      <input type="hidden" name="finalizado" value="true" />
      <textarea
        id="textarea"
        name="comentario"
        v-model="comentario"
        class="form-control"
        data-autoresize
        rows="2"
        placeholder="Adicione um comentário"
        onload="autosize"
      ></textarea>
    </div>
  </form>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      data_devolucao: null,
      colaborador: "",
      comentario: "",
      data_entrega: null,
    };
  },
  props: {
    cartao_data_entrega: null,
    tarefa_id: Number,
  },
  computed: {
    ...mapState("user", ["user"]),
  },
  created() {
    this.data_entrega = this.cartao_data_entrega;
  },
  methods: {
    async encaminhar() {
      const result = await this.$api.put(`tarefa/encaminhar`, {
        tarefa_id: this.tarefa_id,
        colaborador_id: this.colaborador,
        comentario: this.comentario,
        data_devolucao: this.data_devolucao,
        data_entrega: this.data_entrega,
      });

      if (result.data.success) {
        this.$root.$emit('getComentarios');
        this.$emit("getCartao");
        this.$bvModal.hide("encaminhar");
        this.$bvModal.hide("vueMainModal");
      }
    },
  },
};
</script>
